import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6467d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 fv-row mb-3" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "col-lg-6 fv-row mb-3" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "mt-3 border rounded p-3",
  style: {"max-height":"200px","overflow-y":"auto"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "fw-bold d-block" }
const _hoisted_18 = { class: "text-muted fs-7" }
const _hoisted_19 = {
  key: 0,
  class: "text-muted fs-7 ms-2"
}
const _hoisted_20 = { class: "badge badge-light-info" }
const _hoisted_21 = {
  key: 1,
  class: "mt-3 text-muted"
}
const _hoisted_22 = {
  key: 2,
  class: "mt-3 text-muted"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8" }
const _hoisted_27 = { class: "d-flex align-items-center justify-content-between p-3 bg-light-success rounded" }
const _hoisted_28 = { class: "fw-bold d-block" }
const _hoisted_29 = { class: "text-muted fs-7" }
const _hoisted_30 = {
  key: 0,
  class: "text-muted fs-7 ms-2"
}
const _hoisted_31 = { class: "svg-icon svg-icon-3" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { value: "" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = {
  key: 0,
  class: "mt-3 p-3 bg-light rounded"
}
const _hoisted_40 = { class: "fw-bold mb-2" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-6 col-md-3 mb-2" }
const _hoisted_43 = { class: "text-muted fs-7 d-block" }
const _hoisted_44 = { class: "fw-bold" }
const _hoisted_45 = { class: "col-6 col-md-3 mb-2" }
const _hoisted_46 = { class: "text-muted fs-7 d-block" }
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "col-6 col-md-3 mb-2" }
const _hoisted_49 = { class: "text-muted fs-7 d-block" }
const _hoisted_50 = { class: "fw-bold" }
const _hoisted_51 = { class: "col-6 col-md-3 mb-2" }
const _hoisted_52 = { class: "text-muted fs-7 d-block" }
const _hoisted_53 = { class: "fw-bold" }
const _hoisted_54 = { class: "mt-2" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "col-lg-8 fv-row" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "indicator-label" }
const _hoisted_63 = { class: "indicator-progress" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'payments'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('giftSubscription')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitGift,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('searchUser')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchPhone) = $event)),
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('searchByPhone'),
                          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
                        }, null, 40, _hoisted_12), [
                          [_vModelText, _ctx.searchPhone]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchEmail) = $event)),
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('searchByEmail'),
                          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
                        }, null, 40, _hoisted_14), [
                          [_vModelText, _ctx.searchEmail]
                        ])
                      ])
                    ]),
                    (_ctx.searchResults.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (user) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: user.id,
                              class: _normalizeClass(["d-flex align-items-center justify-content-between p-2 rounded cursor-pointer", {
                    'bg-light-primary': _ctx.selectedUser?.id === user.id,
                    'hover-bg-light': _ctx.selectedUser?.id !== user.id,
                  }]),
                              onClick: ($event: any) => (_ctx.selectUser(user))
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(user.fullName), 1),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(user.phone), 1),
                                (user.email)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, " | " + _toDisplayString(user.email), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(user.userType), 1)
                            ], 10, _hoisted_16))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (
                  _ctx.searchPerformed && _ctx.searchResults.length === 0 && !_ctx.isSearching
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.translate('noUsersFound')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isSearching)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(" " + _toDisplayString(_ctx.translate('searching')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.selectedUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('selectedUser')), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.selectedUser.fullName), 1),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.selectedUser.phone), 1),
                            (_ctx.selectedUser.email)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, " | " + _toDisplayString(_ctx.selectedUser.email), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-icon btn-light-danger",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedUser && _ctx.clearSelectedUser(...args)))
                          }, [
                            _createElementVNode("span", _hoisted_31, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                            ])
                          ])
                        ]),
                        _createVNode(_component_Field, {
                          type: "hidden",
                          name: "userId",
                          value: _ctx.selectedUser.id
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('selectPackage')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "packageId",
                      class: "form-select form-select-lg form-select-solid",
                      modelValue: _ctx.selectedPackageId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedPackageId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.translate('selectPackage')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giftPackages, (pkg) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: pkg.id,
                            value: pkg.id
                          }, _toDisplayString(pkg.titleEn) + " - " + _toDisplayString(pkg.titleAr) + " (" + _toDisplayString(pkg.price) + " KWD) ", 9, _hoisted_36))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ErrorMessage, { name: "packageId" })
                      ])
                    ]),
                    (_ctx.selectedPackage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("h6", _hoisted_40, _toDisplayString(_ctx.translate('packageDetails')), 1),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.translate('validity')), 1),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.selectedPackage.daysCovered) + " " + _toDisplayString(_ctx.translate('days')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.translate('iveCredits')), 1),
                              _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.selectedPackage.iveCredits), 1)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.translate('adsCredits')), 1),
                              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.selectedPackage.adsCredits), 1)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.translate('specialAds')), 1),
                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.selectedPackage.specialAds), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", _ctx.getPackageTypeBadge(_ctx.selectedPackage.type)])
                            }, _toDisplayString(_ctx.getPackageTypeLabel(_ctx.selectedPackage.type)), 3)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.translate('note')), 1),
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "note",
                      rows: "3",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('giftNoteOptional')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_ErrorMessage, { name: "note" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  id: "kt_gift_subscription_submit",
                  ref: "submitButton",
                  class: "btn btn-primary",
                  disabled: !_ctx.selectedUser
                }, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.translate('giftPackage')), 1),
                  _createElementVNode("span", _hoisted_63, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_64
                  ])
                ], 8, _hoisted_61)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}